import React from 'react';
import { useLang } from '../../i18n/LanguageProvider';

export const LangToggle = ({ className = '', testId = 'lang-toggle' }) => {
  const { lang, setLang } = useLang();
  const btn = (code) => (
    <button
      type="button"
      onClick={() => setLang(code)}
      aria-pressed={lang === code}
      data-testid={`${testId}-${code}`}
      className={`px-1.5 py-1 transition-colors ${lang === code ? 'text-[#0D5BD7]' : 'text-slate-400 hover:text-[#111827]'}`}
    >
      {code.toUpperCase()}
    </button>
  );
  return (
    <div data-i18n-skip data-testid={testId} className={`flex items-center text-[12px] font-bold tracking-[0.14em] ${className}`}>
      {btn('en')}
      <span className="text-slate-300 select-none">|</span>
      {btn('fr')}
    </div>
  );
};
